import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import ErrorScreen from "../../error/ErrorScreen";
import getDataFromApi from "../../getDataFromApi";
import Loader from "../../Loader";
import YAML from 'yaml';
export default function ModelUploadSummary({ expData, query, id }) {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const customOrder = [
    "Source",
    "Name",
    "Ownership",
    "folder_name",
    "Model Type",
    "Task Type",
    "Architecture",
    "variants",
    "framework",
    "input_model_format",
    "max_size",
    "interpolation",
    "grayscale",
    "normalize",
    "method",
    "Dataset used for training",
    "Benchmark Dataset",
    "Metric Name",
    "Metric Obtained",
      
  ];

  useEffect(() => {
    setLoading(true);
    if (!query) {
      setData(expData);
            setLoading(false);
      return;
    }
    var url = `${window['ENV'].API_URL}/models/detailed/${id}/configuration`;
    url += query;
    getDataFromApi(url, "get")
      .then((r) => {
        if (r?.detail) alert(r.detail);
        else {
          setData(r);
          setLoading(false);
        }
      })
      .catch((e) => {
        setError(e.message);
        console.log(e);
      });
    return () => {
      setError();
    };

  }, [id, query, expData]);
  if (loading) return <Loader />;
  if (error || !data) return <ErrorScreen message={"No Data Found"} />;


  const renderData = (item) => {
     const orderedKeys = Object.keys(item).sort((a, b) => {
    const indexA = customOrder.indexOf(a);
    const indexB = customOrder.indexOf(b);
    if (indexA === -1 && indexB === -1) return 0; // Both not in customOrder
    if (indexA === -1) return 1; // a not in customOrder, move it to end
    if (indexB === -1) return -1; // b not in customOrder, move it to end
    return indexA - indexB; // Compare indices
  });

  return orderedKeys.map((key) => {
    let value = item[key];

      // Skip sensitive keys
      if (["access_key", "secret_key", "session_token", "bucket_name"].includes(key)) {
        return null;
      }
      if(key === "Choose Model") return null;
  
      // Rename keys
      if (key === "folder_name") {
        key = "Model Name";
      }
      const formattedKey = key.replace(/_/g, " ");
      // Handle boolean values
      if (typeof value === "boolean") {
        value = value ? "Yes" : "No";
      }

      if(key === "grayscale" && value?.apply === true){
        <Row className="grey-card4">
                <Col sm="6" className="pt-2 pb-2"><strong>{key}</strong></Col>
                <Col sm="6" className="pt-2 pb-2">{String(value)}</Col>
              </Row>
      }
  
      // Handle array values
      if (Array.isArray(value)) {
        return value.map((val, index) => (
          <div key={`${key}-${index}`}>
            {typeof val === "object" ? (
              renderData(val)
            ) : (
              <Row className="grey-card4">
                <Col sm="6" className="pt-2 pb-2"><strong>{formattedKey}</strong></Col>
                <Col sm="6" className="pt-2 pb-2">{String(val)}</Col>
              </Row>
            )}
          </div>
        ));
      }
  
      // Handle object values with specific logic
      if (typeof value === "object" && value !== null) {
        if (value.hasOwnProperty("apply")) {
          // Check for 'apply' and conditionally render
          if (value.apply) {
            const { apply, ...rest } = value;
            const subContent = Object.entries(rest).map(([subKey, subValue]) => (
              <Row className="grey-card4" key={subKey}>
                <Col sm="6" className="pt-2 pb-2"><strong>{subKey.replace(/_/g, " ")}</strong></Col>
                <Col sm="6" className="pt-2 pb-2">{String(subValue)}</Col>
              </Row>
            ));
            return (
              <div key={key}>
                <Row className="grey-card4">
                  <Col sm="6" className="pt-2 pb-2"><strong>{formattedKey}</strong></Col>
                  <Col sm="6" className="pt-2 pb-2"><strong>Yes</strong></Col>
                </Row>
                {subContent}
              </div>
            );
          }
          return null; // Hide if 'apply' is false
        }
  
        // Recursive render for other nested objects
        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2"><strong>{key}</strong></Col>
            </Row>
            <div className="ms-4">{renderData(value)}</div>
          </div>
        );
      }
  
      // Handle all other cases (primitive values)
      return (
        <Row className="grey-card4" key={key}>
          <Col sm="6" className="pt-2 pb-2"><strong>{formattedKey}</strong></Col>
          <Col sm="6" className="pt-2 pb-2">{String(value)}</Col>
        </Row>
      );
    });
  }
  return (
    <div className="mb-4" style={{overflowX:'auto'}}>
      {data && data.configuration ? renderData(data.configuration) : <p>No configuration data available.</p>}
    </div>
  );
}